export enum FeatureFlags {
  ADMINISTRATION_NAVIGATION = 'administration-navigation',
  ASYNC_PRICE_LIST_IMPORT = 'async-price-list-import',
  DISTRIBUTION_SETTINGS_PLATFORM = 'distribution-settings-platform',
  EDIT_STOCKPOOL_EXTRACTION = 'edit-stockpool-extraction',
  IDENTITY_MANAGEMENT = 'identity-management',
  IMPORT_HUB = 'import-hub',
  NOTIFICATION_SETTINGS = 'notification-settings',
  ORDER_PAYMENT_REPORT = 'order-payment-report',
  PAYMENTS_INTEGRATION = 'payments-integration',
  REPORT_SCHEDULES = 'report-schedules',
  REPORTS_ETL_DELAY_WARNING = 'reports-etl-delay-warning',
  REPORTS_FINANCE_T2 = 'reports-finance-t2',
  SELECTIVE_STEAM_SYNC = 'selective-steam-sync',
  USER_ARCHIVE = 'user-archive',
}
